// extracted by mini-css-extract-plugin
export var columnItem = "_cm-3";
export var columnItemDraggable = "_cm-4";
export var dragHandle = "_cm-0";
export var dragHandleHovered = "_cm-1";
export var dropdown = "_cm-5";
export var dropdownContent = "_cm-7";
export var dropdownInner = "_cm-6";
export var filterDropdownHeader = "_cm-8";
export var icon = "_cm-2";
export var sectionDivider = "_cm-9";